import { FC, useMemo } from "react"

// components
import FeaturedArticles from "../../FeaturedArticles/FeaturedArticles"
import TopicSection from "../../BrowseByTopicSection/TopicSection"

// utils
import { getPanelId, getTabId } from "./Tabs"

// styles
import { topicSectionWrapper } from "../../../pages/{ContentfulHelpArticle.node_locale}/index.module.scss"
import { LogIn } from "../../LogIn/LogIn"

type Props = {
  segment:
    | Queries.HomepageDataQuery["helpCenterHomePage"]["attendee"]
    | Queries.HomepageDataQuery["helpCenterHomePage"]["organizer"]
  prefixedBasePath: string
  logInMicroCopySetEnglish: Queries.CommonIssuesAndQuestionsQuery["logInMicroCopySetEnglish"]
  logInMicroCopySetNonEnglish: Queries.CommonIssuesAndQuestionsQuery["logInMicroCopySetNonEnglish"]
}

export const TabContent: FC<Props> = ({
  segment,
  prefixedBasePath,
  logInMicroCopySetEnglish,
  logInMicroCopySetNonEnglish
}) => {
  const articleContent = useMemo(() => {
    return segment?.content[0]
  }, [segment])

  const topicContent = useMemo(() => {
    return segment?.content[1]
  }, [segment])

  return (
    <>
      <div
        id={getPanelId(segment?.title).split(" ").join("")}
        role="region"
        aria-live="polite"
        aria-labelledby={getTabId(segment?.title).split(" ").join("")}
      >
        {/* <LogIn
          englishMicrocopySet={logInMicroCopySetEnglish}
          nonEnglishMicrocopySet={logInMicroCopySetNonEnglish}
        /> */}
        <FeaturedArticles
          content={articleContent}
          prefixedBasePath={prefixedBasePath}
        />
      </div>
      <div className={topicSectionWrapper}>
        <TopicSection
          content={topicContent}
          prefixedBasePath={prefixedBasePath}
        />
      </div>
    </>
  )
}
